import { PERSONAL_URL } from "../../utils/helpers/api.routes";
import { requests } from "../../utils/helpers/api.services";

export const PersonalService = {
  getPersonals: (body: any) => requests.get(`${PERSONAL_URL}`, body),
};
